import axios from './axiosInstance';

export const listService = async ({
  page,
  limit,
  search
}) => {

  let params = {};

  if(page !== null){
    params.page = page
  }
  if(limit){
    params.limit = limit
  }
  if(search){
    params.search = search
  }
  try{
    const response = await axios({
      url : '/list-service',
      method : 'GET',
      params : params
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}